import { useCallback } from 'react';

import { useIntl } from 'react-intl-next';

import type { AIExperienceMachineContext } from '../utils/xstate/get-ai-experience-service';

export function useCreateGenericChatActionPayload() {
	const { formatMessage } = useIntl();

	return useCallback(
		(history: AIExperienceMachineContext['responseHistory']) => {
			const title = history.entries[0].configItem.title;
			const name = title ? formatMessage(title) : '';

			const dialogues = history.entries.map((entry, index) => {
				const configItemTitle = formatMessage(entry.configItem.title);

				let humanMessage = entry.userInput;

				// The first message should show the config item title
				if (index === 0) {
					humanMessage = `${configItemTitle}\n\n${humanMessage}`;
				}
				// Use the config item title as fallback if the human message is empty
				humanMessage = humanMessage.trim() || configItemTitle;

				return {
					agent_message: { content: entry.markdown },
					human_message: { content: humanMessage },
				};
			});

			return {
				name,
				dialogues,
			};
		},
		[formatMessage],
	);
}
